import useIntersectionObserver from "../hooks/useIntersectionObserver";

export default function Reveal({ children, className = "", delay = 0 }) {
  const [ref, inView] = useIntersectionObserver({ threshold: 0.12, once: true });

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${className}`}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(24px)",
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}
